import {z} from 'zod';

export const WorkshopInsuranceTypeFormSchema = z.object({
  name: z.string().min(1),
});

export type WorkshopInsuranceTypeForm = z.infer<typeof WorkshopInsuranceTypeFormSchema>;
